//  注册全局指令 v-trim  使用方式： <jw-input v-model="xxx" v-trim />
const bindInputEvent = (el) => {
  const inputDom = el.querySelector('input') || el.querySelector('textarea') || el;
  if (!inputDom || (inputDom.tagName !== 'INPUT' && inputDom.tagName !== 'TEXTAREA')) return;
  // 绑定前先移除
  inputDom.removeEventListener('blur', handleTrim, { capture: true });
  inputDom.removeEventListener('keydown', handleKeydown, { capture: true });
  // 统一绑定需要的事件
  inputDom.addEventListener('blur', handleTrim, { capture: true }); // 失焦
  inputDom.addEventListener('keydown', handleKeydown, { capture: true }); // 键盘按下
};

// 移除
const removeInputEvent = (el) => {
  const inputDom = el.querySelector('input') || el.querySelector('textarea') || el;
  if (!inputDom || (inputDom.tagName !== 'INPUT' && inputDom.tagName !== 'TEXTAREA')) return;
  inputDom.removeEventListener('blur', handleTrim, { capture: true });
  inputDom.removeEventListener('keydown', handleKeydown, { capture: true });
};

// 核心处理逻辑：去除首尾空格 + 双向绑定同步
const handleTrim = (e) => {
  const target = e.target;
  const textOldVal = target.value;
  const textNewVal = textOldVal ? textOldVal.trim() : '';
  if (textOldVal === textNewVal) return;
  // 重新赋值，实现去空格
  target.value = textNewVal;
  // 关键：手动派发 input 事件，让ArcoDesign的v-model完美同步数据【必加】
  target.dispatchEvent(new Event('input', { bubbles: true }));
};

// 键盘按下事件处理逻辑
const handleKeydown = (e) => {
  const key = e.key;
  if (key === 'Enter') {
    handleTrim(e);
  }
};

export default {
  mounted(el) {
    bindInputEvent(el);
  },
  updated(el) {
    bindInputEvent(el);
  },
  unmounted(el) {
    removeInputEvent(el);
  }
};
